<template>
	<div class="section-shaped my-0">
		<div class="shape shape-style-1 shape-skew">
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
		</div>
		<div style="height: 180px;"></div>
		<iframe class="airtable-embed airtable-dynamic-height" src="https://airtable.com/embed/shruFlDJjorTXSbaB?backgroundColor=yellow" frameborder="0" onmousewheel="" width="90%" height="3800" style="background: transparent; border: 1px solid #ccc; margin-left: 5%"></iframe>
	</div>
</template>
<script>
export default {};
</script>
